












import { Vue, Component } from 'vue-property-decorator'
import { State } from 'vuex-class'

import MinimalLayout from '@/layouts/Minimal.vue'
import TableOfContent from '@/components/TableOfContent.vue'
import LegalsContent from '@/components/LegalsContent.vue'
import ScrollTopButton from '@/components/ScrollTopButton.vue'

@Component({
  components: {
    LegalsContent,
    TableOfContent,
    MinimalLayout,
    ScrollTopButton
  }
})
export default class Home extends Vue {
  @State(state => state.CONTENT.hideGsc) hideGsc!: boolean
}
